/**
 * Unified request builder for Static Web Generator
 * Provides a single entry point that automatically chooses the appropriate builder
 */

import { WebsiteGeneratorState } from "../../../types/staticWebGenerator";
import { FieldSchema } from "../../../types/staticWebGenerator";

// Import internal builders
import { buildTemplateRequestFromSchema as buildTemplateRequestFromSchemaInternal } from "./buildTemplateRequestFromSchema";
import { buildBlankTemplateRequest } from "./blankTemplateRequest";

/**
 * Build template request from schema (schema-driven builder - schema required)
 * Throws error if schema is not available - user should reload page
 *
 * @param state - Unified state from WebsiteGeneratorWizard
 * @param businessInfo - Business info from useSalon() context
 * @param schema - Field schema from populate-site-template response (required)
 * @param optionalSectionEnabled - Optional section enabled states
 * @returns API request payload
 * @throws Error if schema is null or undefined
 */
export const buildTemplateRequestFromSchema = (
  state: WebsiteGeneratorState,
  businessInfo: any,
  schema: FieldSchema | null,
  optionalSectionEnabled?: Record<string, boolean>,
): any => {
  return buildTemplateRequestFromSchemaInternal(
    state,
    businessInfo,
    schema,
    optionalSectionEnabled,
  );
};

// Re-export buildBlankTemplateRequest
export { buildBlankTemplateRequest };
